import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha-enterprise';
import { FormError } from '@ch/common/components/form/error';
import { QuizContext } from './quiz-context';
import { CaptchaWrapper, QuizCaptchaLoaderWrapper } from './quiz.styled';
import { CAPTCHA_FIELD_NAME } from './hooks/use-quiz-captcha';
import Loading from '@ch/common/components/loading/loading';
import { AppContext } from '../app-context';
import { useLang } from '../use-lang';

interface QuizCaptchaProps {
  size?: 'compact' | 'normal' | 'invisible';
}

const QuizCaptcha: React.FC<QuizCaptchaProps> = ({ size = 'normal' }) => {
  const { refreshToken, recaptchaSiteKey } = React.useContext(QuizContext);
  const { loading } = React.useContext(AppContext);
  const { lang } = useLang();
  const onErrored = () => refreshToken(null);

  return (
    <CaptchaWrapper>
      {recaptchaSiteKey ? (
        <ReCAPTCHA
          sitekey={recaptchaSiteKey}
          onChange={refreshToken}
          size={size}
          onExpired={onErrored}
          onErrored={onErrored}
          hl={lang}
        />
      ) : (
        !loading && (
          <QuizCaptchaLoaderWrapper>
            <Loading $top="65%" $left="100%" />
          </QuizCaptchaLoaderWrapper>
        )
      )}
      <FormError name={CAPTCHA_FIELD_NAME} />
    </CaptchaWrapper>
  );
};

export default QuizCaptcha;
